import React from 'react'

export default function Usp (props) {
  return (
    <>
      <aside className='usp car-usps__usp'>
        {props.src !== null && (<div className='car-usps__icon-wrap'>
            <img src={props.src} alt={typeof props.alt === 'string' ? props.alt : null} />
          </div>)
        }
        <div className='car-usps__text-wrap'>
          <span className='value car-usps__title' dangerouslySetInnerHTML={{ __html: props.title }} />
          <span className='title car-usps__text'>{props.value}</span>
        </div>
      </aside>
      {
        props.showSeperator && (<span className='car-usps__seperator' />)
      }
    </>
  )
}
